export default "__VITE_ASSET__BnCslWA0__"